import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  IconButton,
  Divider,
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { customerApi } from '../../api/client';

export const CustomerCreate: React.FC = () => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    name: '',
    cvr: '',
    email: '',
    phone: '',
    website: '',
    address: '',
    city: '',
    postalCode: '',
    country: '',
    notes: '',
  });

  const handleChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [field]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!form.name.trim()) {
      setError('Firmanavn er påkrævet');
      return;
    }
    setSaving(true);
    setError('');
    try {
      const res = await customerApi.create(form);
      navigate(`/customers/${res.data.data.id}`);
    } catch (err: any) {
      setError(err.response?.data?.error || 'Kunne ikke oprette kunde');
      setSaving(false);
    }
  };

  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1} mb={1.5}>
        <IconButton size="small" onClick={() => navigate('/customers')}>
          <ArrowBackIcon sx={{ fontSize: '1.1rem' }} />
        </IconButton>
        <Typography variant="h6" fontWeight={600} sx={{ fontSize: '1rem' }}>
          Ny kunde
        </Typography>
      </Box>

      <Card sx={{ maxWidth: 600 }}>
        <CardContent sx={{ p: 2 }}>
          {error && (
            <Typography color="error" variant="body2" sx={{ mb: 1.5, fontSize: '0.75rem' }}>
              {error}
            </Typography>
          )}

          <TextField
            size="small"
            label="Firmanavn *"
            value={form.name}
            onChange={handleChange('name')}
            fullWidth
            sx={{ mb: 1.5 }}
            autoFocus
          />

          <Box display="flex" gap={1.5} mb={1.5}>
            <TextField size="small" label="CVR / Momsnr." value={form.cvr} onChange={handleChange('cvr')} fullWidth />
            <TextField size="small" label="Telefon" value={form.phone} onChange={handleChange('phone')} fullWidth />
          </Box>

          <Box display="flex" gap={1.5} mb={1.5}>
            <TextField size="small" label="Email" value={form.email} onChange={handleChange('email')} fullWidth />
            <TextField size="small" label="Website" value={form.website} onChange={handleChange('website')} fullWidth />
          </Box>

          <Divider sx={{ my: 1.5 }} />
          <Typography variant="subtitle2" sx={{ fontSize: '0.8rem', mb: 1 }}>Adresse</Typography>

          <TextField size="small" label="Adresse" value={form.address} onChange={handleChange('address')} fullWidth sx={{ mb: 1.5 }} />

          <Box display="flex" gap={1.5} mb={1.5}>
            <TextField size="small" label="Postnr." value={form.postalCode} onChange={handleChange('postalCode')} sx={{ width: '30%' }} />
            <TextField size="small" label="By" value={form.city} onChange={handleChange('city')} fullWidth />
            <TextField size="small" label="Land" value={form.country} onChange={handleChange('country')} sx={{ width: '30%' }} />
          </Box>

          <Divider sx={{ my: 1.5 }} />

          <TextField size="small" label="Noter" value={form.notes} onChange={handleChange('notes')} fullWidth multiline rows={3} sx={{ mb: 2 }} />

          <Box display="flex" gap={1} justifyContent="flex-end">
            <Button onClick={() => navigate('/customers')} sx={{ fontSize: '0.8rem' }}>Annuller</Button>
            <Button variant="contained" onClick={handleSubmit} disabled={saving} sx={{ fontSize: '0.8rem' }}>
              {saving ? 'Opretter...' : 'Opret kunde'}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};
